import { render } from "./VisionMission.vue?vue&type=template&id=c997fb0c&scoped=true&ts=true"
import script from "./VisionMission.ts?vue&type=script&lang=ts"
export * from "./VisionMission.ts?vue&type=script&lang=ts"

import "./VisionMission.scss?vue&type=style&index=0&id=c997fb0c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c997fb0c"]])

export default __exports__